import { Component, Input, OnInit } from '@angular/core';

export type ChipColour =
  | 'teal'
  | 'orange'
  | 'green-no-outline'
  | 'red-no-outline'
  | 'grey-no-outline'
  | 'blue-no-outline'
  | 'amber-no-outline'
  | 'indigo-no-outline';

@Component({
  selector: 'csi-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css']
})
export class ChipComponent implements OnInit {
  @Input() text: string = '';
  @Input() value: string = '';
  @Input() colour: ChipColour = 'teal';
  @Input() tooltip: string = '';
  @Input() icon: string = '';
  @Input() trailingIcon = '';
  @Input() applySideMargin: boolean = true;
  @Input() isCompact: boolean = false;
  @Input() isEmphasis = false;

  constructor() {}

  ngOnInit() {}
}
